import React from 'react';
import CategoryAdItem from '../items/category_ad_item';

const Result = ({ items }) => {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 px-0">
            {items.map((item, index) => (
                <CategoryAdItem key={index} item={item} />
            ))}
        </div>
    );
};

export default Result;